export enum OptimisationProjectStatusEnum {
  DRAFT = 0,
  RUNNING = 1,
  ENDED = 2,
}

export enum OptimisationProjectNetworkEnum {
  FACEBOOK = 0,
  YOUTUBE = 1,
}

export enum OptimisationProjectTypeEnum {
  OWN = 0,
  COMPETITOR = 1,
}

export enum OptimisationTestStatusEnum {
  FAILED = -1,
  PROCESSING = 0,
  READY = 1,
  RUNNING = 2,
  WAITING_FOR_DATA = 3,
  ENDED = 4,
}

export enum OptimisationTestTypeEnum {
  THUMBS = 0,
  TIPS = 1,
  SEQUENCES = 2,
  FINALISATION = 3,
  INTRO = 4,
  TITLE = 5,
}

export enum TopicsMaRatingEnum {
  NA = 0,
  VERY_BAD = 1,
  BAD = 2,
  GOOD = 3,
  VERY_GOOD = 4,
}

export enum ReleaseCompilationTypeEnum {
  FRESH = 1,
  REUSE = 2,
  DISTRIBUTION = 3,
  REDISTRIBUTION = 4,
  MODIFIED_REDISTRIBUTION = 5,
  REDISTRIBUTION_PREDICTED = 6,
}

export enum ReleaseStatusEnum {
  DRAFT = 1,
  PREPARED = 2,
  WAITING = 3,
  SCHEDULED = 4,
  POSTED = 5,
  REJECTED = 6,
}

export enum EventsStatusEnum {
  DRAFT = 1,
  SENT = 2,
  CANCELED = 3,
}

export enum TestingCurrencies {
  EUR = 'EUR',
  KRW = 'KRW',
  INR = 'INR',
  IDR = 'IDR',
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
  DEFAULT = 'DEFAULT',
}

export enum TopicsLevel {
  GENRE = 1,
  SUBGENRE = 2,
  OBJECTS = 3,
  CHARACTERS = 4,
  LOCATIONS = 5,
}

export enum TopicMaRating {
  NA = 0,
  VERY_BAD = 1,
  BAD = 2,
  GOOD = 3,
  VERY_GOOD = 4,
}

export enum recipientType {
  COMPANY = 'COMPANY',
  INDIVIDUAL = 'INDIVIDUAL',
}

export enum paymentType {
  DOMESTIC = 'Domestic',
  EUROPEAN = 'European',
  INTERNATIONAL = 'International',
}

export enum PaymentMethod {
  Bank = 'bank',
  Paypal = 'paypal',
  Payoneer = 'payoneer',
}

export enum PaymentBank {
  REVOLUT = 'revolut',
  PAYPAL = 'paypal',
  SWEDBANK = 'swedbank',
  PAYONEER = 'payoneer',
}

export enum InvoiceSource {
  Manual = 'manual',
  Freelancer = 'freelancer',
  Import = 'import',
}

export enum InvoiceStatus {
  PreReceived = 0,
  Received = 1,
  Paid = 3,
}

export enum VideoFramesExportType {
  PART_VIDEO = 1,
  FULL_VIDEO = 2,
}

export enum VideoFramesExportStatus {
  IN_PROGGRESS = 1,
  COMPLETED = 2,
  FAILED = 3,
}

export enum EytvStatus {
  New = 1,
  Downloaded = 2,
  Pending = 3,
  Done = 4,
}

export enum ProductionProjectNoteStatusEnum {
  CANCELED = 3,
  INFO = 1,
  WARNING = 2,
}

export enum AssignTopicsStatus {
  DEFAULT = 1,
  ASSIGNED = 2,
  CONFIRMED = 3,
}

export enum FreelancerStatus {
  EMPLOYED = 'Employed',
  UNEMPLOYED = 'Unemployed',
}

export enum GaNetworkType {
  SEARCH = 5,
  WATCH = 6,
}

export enum ReleasePredictionStatus {
  PENDING = 1,
  SCHEDULED = 2,
  SKIPPED = 3,
}

export enum ImageGenerationProjectStatus {
  DRAFT = 1,
  PENDING = 2,
  DONE = 3,
  FAILED = 4,
}

export enum ImageQueryType {
  SEARCH = 0,
  PROMPTS = 1,
  HASHTAGS = 2,
  GETTY = 3,
}

export enum EditorialDistributionStatus {
  SCHEDULED = 1,
  POSTED = 2,
}

export enum EditorialDistributionBenchmarkReach {
  NOT_REACHED = 1,
  PENDING = 2,
  REACHED = 3,
}

export enum EditorialPostsStatus {
  ACTIVE = 1,
  ENDED = 2,
}

export enum DistributionDepartmentsEnum {
  ALL = 1,
  NATIVE = 2,
  THIRD_PT = 3,
}

export enum BPTestingProjectStatus {
  ACTIVE = 1,
  ENDED = 2,
}

export enum BPTestStatus {
  PROCESSING = 1,
  ACTIVE = 2,
  ENDED = 3,
  FAILED = 4,
}

export enum ImageDistributionStatus {
  DRAFT = 1,
  POSTED = 2,
  SCHEDULED = 3,
}

export enum YoutubeTestsViewsThreshold {
  THUMBS = 50,
  OTHER = 400,
}

export enum IgProfileTier {
  S = 1,
  A = 2,
  B = 3,
  C = 4,
  D = 5,
}

export enum CoverImagesProjectStatus {
  PENDING = 1,
  REVIEW = 2,
  OK = 3,
  RESOLVED = 4,
  SENT = 5,
}

export enum CoverImagesImageStatus {
  PENDING = 'pending',
  FIXING = 'fixing',
  APPROVED = 'approved',
  RESOLVED = 'resolved',
  SENT = 'sent',
}

export enum SubsGenerationProjectVideoStatus {
  NOT_READY = 1,
  GENERATING = 2,
  DONE = 3,
  FAILED = 4,
}

export enum SocialPostsImportStatus {
  PENDING = 1,
  DONE = 2,
  EXPORTED = 3,
}

export enum MLProjectStatus {
  DRAFT = 1,
  PENDING = 2,
  DONE = 3,
}

export enum MLProjectTranslationStatus {
  PENDING = 1,
  DONE = 2,
}

export enum MLProjectTranslationVideoStatus {
  PENDING = 1,
  GENERATING = 2,
  DONE = 3,
  FAILED = 4,
}

export enum EditorialFacebookPostNetwork {
  FACEBOOK = 1,
  INSTAGRAM = 2,
  THREADS = 3,
  PINTEREST = 4,
  TWITTER = 5,
  REELS = 6,
  TEXT_STATUS = 7,
  WHATSAPP = 8,
  BLUESKY = 9,
  YOUTUBE_SHORTS = 10,
  FACEBOOK_VIDEO = 11,
  LINKEDIN = 12,
  TIKTOK = 13,
  MSN = 14,
  REDDIT = 15,
}

export enum EditorialFacebookPostType {
  LINK = 1,
  IMAGE = 2,
  VIDEO = 3,
  REEL = 4,
  STORY = 5,
  TEXT = 6,
  IMAGE_ALBUM = 7,
  SHARE = 8,
  PLACEHOLDER = 9,
}

export enum EditorialFacebookPostQueueStatus {
  DRAFT = 1,
  POSTED = 2,
  FAILED = 3,
}

export enum EYTVLinkStatus {
  PENDING = 1,
  DONE = 2,
  FAILED = 3,
}

export enum DQActionType {
  STOP_QUEUE = 1,
  START_QUEUE = 2,
  CHANGE_FREQUENCY = 3,
}

export enum VideoFactorySettingsType {
  STORY_PROMPT = 1,
  SCRIPT_PROMPT = 2,
}

export enum VideoFactoryProjectStatus {
  GENERATING_STORY = 1,
  GENERATING_SCRIPT = 2,
  GENERATING_IMAGES = 3,
  GENERATING_VOICEOVERS = 4,
  GENERATING_FINAL_VIDEO = 5,
  COMPLETED = 6,
  FAILED = 7,
  GENERATING_IMAGE_VIDEOS = 8,
  GENERATING_ANIMATED_IMAGES_VIDEO = 9,
  DRAFT = 10,
}

export enum VideoCompilerCompilationStatus {
  DRAFT = 1,
  IN_PROCESS = 2,
  COMPLETED = 3,
  FAILED = 4,
}

export enum VideoCompilerCompilationType {
  TEST = 'test',
  FINAL = 'final',
}

export enum VacationStatus {
  Approved = 'approved',
  Pending = 'pending',
  Declined = 'declined',
  Auto_Declined = 'auto_declined',
}

export enum InvoiceGenerationStatus {
  Approved = 'approved',
  Pending = 'pending',
  Needs_Action = 'needs_action',
  Rejected = 'rejected',
  Finances_Rejected = 'finances_rejected',
}

export enum VacationType {
  Instant = 'instant',
  Annual = 'annual',
}

export enum VacationRequestType {
  Paid = 'paid',
  Unpaid = 'unpaid',
}
